module.exports = __webpack_public_path__ + "media/icons/blank-file-4612f48c.png";